interface ChevronUpIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export default function ChevronUpIcon({
  width = 24,
  height = 24,
  color = 'currentColor',
  className,
}: ChevronUpIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.2002 14.4001L12.0002 9.6001L16.8002 14.4001"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
